/* eslint-disable no-useless-escape */
import { boot } from "quasar/wrappers";
import { bffClient, globals } from "ngt-app-core";

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)

let bff = {
  api: null,
  auth: null,
  bffSettings: null,
};

export default boot(({ app }) => {
  // for use inside Vue files (Options API) through this.$bff
  console.log("bffClient booting...");

  const env = import.meta.env;
  bff = bffClient(app, env);

  globals.set("bff", bff)
  globals.set("env", env)

  app.config.globalProperties.$bff = bff;
  app.config.globalProperties.$env = env;
  // ^ ^ ^ this will allow you to use this.$bff (for Vue Options API form)
  //       so you won't necessarily have to import bffClient in each vue file
});

export { bff };
